module.exports = __webpack_public_path__ + "static/media/soap-bubbles.39f43dbc.bmp";